import { Dimensions as APIDimensions } from '~api/som';

import { useTranslation } from 'react-i18next';

interface Props {
  dimensions?: APIDimensions;
}

export function Dimensions(props: Props) {
  const { dimensions } = props;
  const { i18n } = useTranslation();

  const values = [dimensions?.length, dimensions?.width, dimensions?.height].filter(Boolean);

  if (!values.length) {
    return null;
  }

  return values
    .map((value, index) => {
      const isLast = values.length - 1 === index;

      // This number cast might look a little uneccesary, but it's due to a runtime type issue where we
      // change the type of uint64 to a number, but in reality (runtime) it's actually a string.
      return Number(value).toLocaleString(i18n.resolvedLanguage, {
        // We only append `mm` to the last dimension property, others should only be presented as decimals
        style: isLast ? 'unit' : 'decimal',
        unitDisplay: 'short',
        unit: 'millimeter',
      });
    })
    .join('×');
}
